module.exports = __webpack_public_path__ + "static/media/whatsapp-blue.3ff91c04.svg";